import { render } from "./pl35-5ma.vue?vue&type=template&id=ca398d68&scoped=true"
import script from "./pl35-5ma.vue?vue&type=script&lang=js"
export * from "./pl35-5ma.vue?vue&type=script&lang=js"

import "./pl35-5ma.vue?vue&type=style&index=0&id=ca398d68&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca398d68"]])

export default __exports__